var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.hasHeader ? _c('div', [_vm._t("header", function () {
    return [_c('website-header', {
      staticStyle: {
        "position": "absolute"
      }
    })];
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "listwrap2"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "newlist"
  }, _vm._l(_vm.newsList, function (info, index) {
    return _c('li', {
      key: index
    }, [_c('p', {
      staticClass: "p1"
    }, [_c('a', {
      attrs: {
        "href": info.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(info.title))])]), _vm._v(" "), _c('p', {
      staticClass: "p2"
    }, [_c('span', [_vm._v(_vm._s(info.date))])])]);
  }), 0)]), _vm._v(" "), _vm.hasFooter ? _c('div', [_vm._t("footer", function () {
    return [_c('website-footer')];
  })], 2) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', [_vm._v("News")])]);
}];
export { render, staticRenderFns };